import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for AnalysisRoot component
 */
export const useAnalysisRootStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2),
        overflow: 'auto',
    },
    header: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 700,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        color: theme.palette.text.secondary,
    },
    summaryCards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    summaryCard: {
        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
        borderRadius: theme.spacing(2),
    },
    summaryCardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    summaryValue: {
        fontSize: '2rem',
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    summaryLabel: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    tableContainer: {
        marginTop: theme.spacing(2),
    },
    headerCell: {
        fontWeight: 700,
        backgroundColor: theme.palette.grey[100],
    },
    variancePositive: {
        color: theme.palette.error.main,
        fontWeight: 600,
    },
    varianceNegative: {
        color: theme.palette.success.main,
        fontWeight: 600,
    },
    varianceZero: {
        color: theme.palette.text.secondary,
    },
    varianceIcon: {
        marginRight: theme.spacing(0.5),
        fontSize: '1rem',
        verticalAlign: 'middle',
    },
    currencyCell: {
        fontFamily: 'monospace',
        fontSize: '0.9rem',
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(8),
        color: theme.palette.text.secondary,
    },
    loadingState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(8),
    },
}))
